export default __webpack_public_path__ + "meetingRoomParticipants2.json";